import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-green-label',
  templateUrl: './green-label.component.html',
  styleUrls: ['./green-label.component.scss'],
  standalone: false
})
export class GreenLabelComponent {
  @Input()
  disabled = false;

  @Input()
  label: string;
}
